// Framework brush "F." logo — from user's actual brand guide
export function FWLogo({ size = 32 }) {
    return (
        <img
            src="/brand/framework-mark.png"
            alt="Framework Tennis"
            style={{
                height: size,
                width: "auto",
                display: "block",
                objectFit: "contain",
            }}
        />
    );
}

// String Theory brain + racquet + centered ball mark — from user's uploaded logo
export function STLogo({ size = 36, variant = "mark" }) {
    const src = variant === "full"
        ? "/brand/string-theory-logo-full.png"
        : "/brand/string-theory-mark.png";
    return (
        <img
            src={src}
            alt="String Theory Performance"
            style={{
                height: size,
                width: "auto",
                display: "block",
                objectFit: "contain",
            }}
        />
    );
}
